import * as am4core from "@amcharts/amcharts4/core";

// the outer array is the line series and the inner array values are the y-values for this series
export type LinePlotData = number[][];

export class PlotChartOptions {
    colors: string[]; // CSS values
    colorSet: am4core.ColorSet;
    fillColors: boolean = false;
    lineStrokeWidth: number = 3.0;
    xAxisRotation = 50;
    hideLabels: boolean = false;
    noDataTxt: string = null;
    cursor: boolean = false;
    minGridDistance: number = 1;

    xLabel: string = "";
    yLabel: string = "";

    individualAxisStartIndex: number = -1; // for XY charts: set this to an index from which each data series shall have its own y-Axis on the right
    value2ndAxisLabel: string[] =[] ;
    seriesHidden: boolean[] = []; // set array elements to 'true' to hide series on page load (starting from individualAxisStartIndex)
    axisIdPrefix: string = "";

    constructor() {
    }
}

export class ChartDetail {
    name: string; // the internal key
    value: string; // the not formatted value
    title: string; // the localized display name
    displayValue: string; // the localized value (dots vs commas in case of numbers)

    constructor(name: string, value: string, title: string, displayValue: string) {
        this.name = name;
        this.value = value;
        this.title = title;
        this.displayValue = displayValue;
    }
}

export class ChartExportOptions {
    title: string = null; // of the pdf
    subTitles: string[] = [];
    titleDetails: ChartDetail[] = [];
    addTableIDs: string[] = []; // html table IDs to convert to PDF
    footerNote: string = "";

    // chart headlines
    headlineTag: string = "h2"; // we will search up the DOM tree to add this text as headline. make sure it is lowercase!
    headlines: string[] = null; // use this to manually set headlines. takes precedence over the headlineTag
    details: {
        [chartID: string]: ChartDetail[]; // printed above the chart
    }

    chartFitX = 550;
    chartFitY = 390; //326;
    //maxChartsPerPage = 2;       // force a new page after this // not working reliably because a chart might break before the count is reached
    //chartOffset = 1;            // start chart count at 1 - causing only 1 chart to be at the first page
    lastChartsSamePage = -1;

    addImprint = true;

    constructor() {
        this.details = {} // map with chartID as key
    }
}
